import React, { useState } from "react";
import Layout from "../Layout";
import Add from "../Components/EmployeeSalary/Add";
import List from "../Components/EmployeeSalary/List";

function EmployeeSalary() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const [isSalaryIncrement, setIsSalaryIncrement] = useState(false);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Emplyoee Salary</h1>
          </div>
          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} setIsSalaryIncrement={setIsSalaryIncrement}/>
          ) : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} isSalaryIncrement={isSalaryIncrement}/>
          )}
        </section>
      </div>
    </Layout>
  );
}

export default EmployeeSalary;
